import CancelIcon from '@mui/icons-material/Cancel'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton, styled } from '@mui/material'
import OverflowFilename from 'components/ui/OverflowFilename'
import { checkFileError } from 'utils/file'

import { DeleteFileHandler } from './types'

interface Props {
  onDeleteFile: DeleteFileHandler
  files: (File & { id: number })[]
}

const MyOverflowFilename = styled(OverflowFilename)(({ theme }) => ({
  marginRight: theme.spacing(1),
}))

const Ul = styled('ul')({
  overflow: 'auto',
  margin: 0,
  padding: 0,
})

const Li = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  color: theme.palette.text.secondary,
  '& + &': {
    borderTop: `solid 1px ${theme.palette.grey[200]}`,
  },
}))

const UploadFileList = ({ files, onDeleteFile }: Props) => {
  const rows = files.map((file, idx) => {
    const { name, id } = file
    const errors = checkFileError(file)

    const handleDeleteClick = () => {
      onDeleteFile(idx)
    }

    return (
      <Li key={id}>
        {errors.length > 0 && <CancelIcon fontSize="small" color="error" sx={{ mr: 1 }} />}
        <MyOverflowFilename filename={name} />
        <IconButton
          size="small"
          onClick={handleDeleteClick}
          sx={{
            ml: 'auto',
            color: 'text.hint',
            padding: '3px',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Li>
    )
  })

  return <Ul>{rows}</Ul>
}

export default UploadFileList
